import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import CustomerInformation from "./Registration/Components/CustomerInformation";
import ActivationType from "./Registration/Components/ActivationType";
import PaymentMethod from "./Registration/Components/PaymentMethod";
import TermsCondition from "./Registration/Components/TermsCondition";
import ConfirmPage from "./Registration/Components/ConfirmPage";
import CancellationOBD from "./Cancellation/CancellationOBD";
import ReactivationOBD from "./Reactivation/ReactivationOBD";
import DevicePlanUpdate from "./DevicePlanUpdate/DevicePlanUpdate";
import CreditCardUpdate from "./CreditCardUpdate/CreditCardUpdate";
import "./App.css";
import axios from "axios";
import base_url from "./api/bootapi";
import { useStateValue } from "./Registration/Components/ContextAPI/StateProvider";
import { ToastProvider } from "react-toast-notifications";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-credit-cards/es/styles-compiled.css";
import IMEIReactivation from "./IMEIReactivation/IMEIReactivation";
import DormantCancellation from "./DormantCancellation/DormantCancellation";
import SmspackbuyService from "./SmsPackBuyService/smspackbuyService";
import Pricing from "./Pricing/Pricing";
import NumberConfirmation from "./NumberConfirmation/NumberConfirmation";
// let durationobj = {
//   1: "monthly",
//   3: "quarterly",
//   6: "halfyearly",
//   12: "yearly",
// };

//
const App = () => {
  const [
    {
      customerInformation,
      activationType,
      paymentMethod,
      terms,
      movetoactivationpage,
      movetopaymentpage,
      movetotermspage,
      movetoconfirmpage,
      userexists,
      shownavigationthroughtopbar,
    },
    dispatch,
  ] = useStateValue();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (location.pathname === "/") {
      history.push("/registration/customer-information");
    }

    getservicerules();
    getservicePlan();
    if (
      location.pathname === "/" ||
      location.pathname === "/registration/customer-information" ||
      location.pathname === "/registration/activation-type" ||
      location.pathname === "/registration/payment-method" ||
      location.pathname === "/registration/terms" ||
      location.pathname === "/registration/confirm"
    ) {
      getcountry();
      getstate();
      gettimezone();
      getserviceProvider();
      if (!sessionStorage.getItem("customerInformation")) {
        sessionStorage.setItem(
          "customerInformation",
          JSON.stringify(customerInformation)
        );
        sessionStorage.setItem(
          "activationType",
          JSON.stringify(activationType)
        );
        sessionStorage.setItem("paymentMethod", JSON.stringify(paymentMethod));
        sessionStorage.setItem("terms", JSON.stringify(terms));
        sessionStorage.setItem("movetoactivationpage", movetoactivationpage);
        sessionStorage.setItem("movetopaymentpage", movetopaymentpage);
        sessionStorage.setItem("movetotermspage", movetotermspage);
        sessionStorage.setItem("movetoconfirmpage", movetoconfirmpage);
        sessionStorage.setItem("userexists", userexists);
        sessionStorage.setItem(
          "shownavigationthroughtopbar",
          shownavigationthroughtopbar
        );
      }
    }
  }, []);
  const getservicerules = () => {
    axios.get(`${base_url}/info/service_plan/rules`).then((res) => {
      if (res.data.status) {
        let obj = {};
        res.data.plans.forEach((ele) => {
          obj[ele["service_plan_id"]] = ele;
        });
        dispatch({
          type: "ADD_TO_SERVICERULES",
          servicerules: obj,
        });
      }
    });
  };
  const getcountry = () => {
    axios.get(`${base_url}/info/countries`).then((res) => {
      dispatch({
        type: "ADD_TO_COUNTRY",
        countries: res.data.countries,
      });
    });
  };
  const getstate = () => {
    axios.get(`${base_url}/info/country/250/states`).then((res) => {
      dispatch({
        type: "ADD_TO_STATE",
        states: res.data.states,
      });
    });
  };
  const gettimezone = () => {
    axios.get(`${base_url}/info/timezones`).then((res) => {
      dispatch({
        type: "ADD_TO_TIMEZONE",
        timezone: res.data.time_zone,
      });
    });
  };
  const getserviceProvider = () => {
    axios.get(`${base_url}/info/mobile/service_provider`).then((res) => {
      dispatch({
        type: "ADD_TO_SERVICEPROVIDER",
        serviceProvider: res.data.providers,
      });
    });
  };
  const getservicePlan = () => {
    axios.get(`${base_url}/info/service_plan/revised`).then((res) => {
      if (res.data.status) {
        let obj = {};
        res.data.plans.forEach((ele) => {
          obj[ele["service_plan_id"]] = ele;
        });
        dispatch({
          type: "ADD_TO_SERVICEPLAN_GPS",
          servicePlan: obj,
        });
      }
    });
    axios
      .get(`${base_url}/info/app_conf?key=discount_3`)
      .then((res) => {
        if (res.data.status) {
          // let quaterlydiscount = Number(res.data["value"]["key_value"]);
          dispatch({
            type: "ADD_TO_DISCOUNT_QUARTER",
            discount_quarter: Number(res.data["value"]["key_value"]),
          });
          axios
            .get(`${base_url}/info/app_conf?key=discount_12`)
            .then((res2) => {
              if (res2.data.status) {
                // let yearlydiscount = Number(res2.data["value"]["key_value"]);
                dispatch({
                  type: "ADD_TO_DISCOUNT_YEARLY",
                  discount_yearly: Number(res2.data["value"]["key_value"]),
                });
                // axios.get(`${base_url}/info/service_plan`).then((res) => {
                //   if (res.data.status) {
                //     let obj = {};
                //     res.data.plans.forEach((item) => {
                //       obj[
                //         `${item["base_device_frequency"]}${
                //           durationobj[item["duration"]]
                //         }`
                //       ] = item;
                //     });
                //     Object.keys(obj).forEach((item) => {
                //       if (Number(obj[item]["duration"]) !== 1) {
                //         let duration = Number(obj[item]["duration"]);
                //         let durationpercent =
                //           duration === 3 ? quaterlydiscount : yearlydiscount;
                //         let price1month =
                //           obj[`${obj[item]["base_device_frequency"]}monthly`][
                //             "price"
                //           ];
                //         let totalprice = parseFloat(
                //           (Number(price1month) *
                //             duration *
                //             (100 - durationpercent)) /
                //             100
                //         ).toFixed(2);
                //         let monthlyprice = parseFloat(
                //           Number(totalprice) / duration
                //         ).toFixed(2);
                //         obj[item]["total"] = totalprice;
                //         obj[item]["monthlyprice"] = monthlyprice;
                //       }
                //     });
                //     dispatch({
                //       type: "ADD_TO_SERVICEPLAN_GPS",
                //       servicePlan: obj,
                //     });
                //   }
                // });
              } else {
                // callserviceapi();
              }
            })
            .catch((err) => {});
        } else {
          // callserviceapi();
        }
      })
      .catch((err) => {
        // callserviceapi();
      });

    axios
      .get(`${base_url}/info/service_plan/revised?category=obd`)
      .then((res) => {
        if (res.data.status) {
          let obj = {};
          res.data.plans.forEach((ele) => {
            obj[ele["service_plan_id"]] = ele;
          });
          dispatch({
            type: "ADD_TO_SERVICEPLAN",
            servicePlan: obj,
          });
        }
      });
    // axios.get(`${base_url}/info/service_plan/obd`).then((res) => {
    //   dispatch({
    //     type: "ADD_TO_SERVICEPLAN",
    //     servicePlan: res.data.plans,
    //   });
    // });
  };

  // const callserviceapi = () => {
  //   axios.get(`${base_url}/info/service_plan`).then((res) => {
  //     if (res.data.status) {
  //       let obj = {};
  //       res.data.plans.forEach((item) => {
  //         obj[
  //           `${item["base_device_frequency"]}${durationobj[item["duration"]]}`
  //         ] = item;
  //         obj["monthlyprice"] = item["price"];
  //       });
  //       dispatch({
  //         type: "ADD_TO_SERVICEPLAN_GPS",
  //         servicePlan: obj,
  //       });
  //     }
  //   });
  // };
  return (
    <ToastProvider>
      <div>
        <Switch>
          <Route path="/registration/customer-information">
            <CustomerInformation />
          </Route>
          <Route path="/registration/activation-type">
            <ActivationType />
          </Route>
          <Route path="/registration/payment-method">
            <PaymentMethod />
          </Route>
          <Route path="/registration/terms">
            <TermsCondition />
          </Route>
          <Route path="/registration/confirm">
            <ConfirmPage />
          </Route>
          <Route path="/cancellation">
            <CancellationOBD />
          </Route>
          <Route path="/dormant-cancellation">
            <DormantCancellation />
          </Route>
          <Route path="/reactivation">
            <ReactivationOBD />
          </Route>
          <Route path="/device-plan/update">
            <DevicePlanUpdate />
          </Route>
          <Route path="/credit-card/update">
            <CreditCardUpdate />
          </Route>
          <Route path="/activate-dormantfee">
            <IMEIReactivation type={"dontpay"} />
          </Route>
          <Route path="/pay-dormantfee">
            <IMEIReactivation type={"pay"} />
          </Route>
          <Route path="/activate-smspack">
            <SmspackbuyService />
          </Route>
          <Route path="/pricing">
            <Pricing />
          </Route>
          <Route path="/phone-confirmation">
            <NumberConfirmation />
          </Route>
        </Switch>
      </div>
    </ToastProvider>
  );
};

export default App;
